/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Contract, ContractFactory, Interface, } from "ethers";
const _abi = [
    {
        inputs: [],
        name: "DER_Split_Error",
        type: "error",
    },
    {
        inputs: [],
        name: "expmod_Error",
        type: "error",
    },
    {
        inputs: [],
        name: "k256Decompress_Invalid_Length_Error",
        type: "error",
    },
    {
        inputs: [],
        name: "k256DeriveY_Invalid_Prefix_Error",
        type: "error",
    },
    {
        inputs: [],
        name: "recoverV_Error",
        type: "error",
    },
];
const _bytecode = "0x60808060405234601757603a9081601d823930815050f35b600080fdfe600080fdfea264697066735822122088086c71937e9deb83a37dee3b895986f7df87e3e587aeab2b7506e6a7be8ca164736f6c63430008100033";
const isSuperArgs = (xs) => xs.length > 1;
export class EthereumUtils__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static createInterface() {
        return new Interface(_abi);
    }
    static connect(address, runner) {
        return new Contract(address, _abi, runner);
    }
}
EthereumUtils__factory.bytecode = _bytecode;
EthereumUtils__factory.abi = _abi;
//# sourceMappingURL=EthereumUtils__factory.js.map